// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import { getLogs } from 'api/logs';

// ----------------------------------------------------------------------

const defaultParams = {
    pageNo: 1,
    perPage: 5
};

const initialState = {
    // for account settings profile
    profileActivities: {
        logs: [],
        isFetching: true,
        total: 0,
        params: defaultParams
    },
    totalLogsCount: 0
};

const slice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        // SET Logs
        setLogs(state, action) {
            const { data, isUpdateTotalCount } = action.payload;
            const {
                data: { data: list = [] },
                total = 0
            } = data;
            state.profileActivities.logs = list;
            if (state.profileActivities.total === 0 || isUpdateTotalCount) {
                state.profileActivities.total = total;
            }
        },
        // SET Params
        setParams(state, action) {
            const { params } = action.payload;
            state.profileActivities.params = params;
        },
        // SET Is Fetcing Resources
        setIsFetchingLogs(state, action) {
            const { status } = action.payload;
            state.profileActivities.isFetching = status;
        }
    }
});

// eslint-disable-next-line prettier/prettier
export const {
    setLogs,
    setParams,
    setIsFetchingLogs,
} = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchLogs(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getLogs(params);
            dispatch(
                slice.actions.setLogs({
                    data: result?.data || [],
                    isUpdateTotalCount
                })
            );
            return result?.data?.data || [];
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setLogs({
                    data: {
                        list: []
                    }
                })
            );
            return [];
        }
    };
}
